var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#054940"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9998 23.7487H37.4998C37.4998 17.3362 32.6586 12.5 26.2373 12.5V15C31.3148 15 34.9998 18.6787 34.9998 23.7487Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2499 20C28.8786 20 29.9999 21.1212 29.9999 23.75H32.4999C32.4999 19.7187 30.2811 17.5 26.2499 17.5V20ZM30.5274 26.8037C30.2872 26.5854 29.9715 26.469 29.6471 26.479C29.3227 26.4891 29.0149 26.6248 28.7886 26.8575L25.7974 29.9337C25.0774 29.7962 23.6299 29.345 22.1399 27.8587C20.6499 26.3675 20.1986 24.9162 20.0649 24.2012L23.1386 21.2087C23.3716 20.9827 23.5075 20.6748 23.5176 20.3503C23.5276 20.0257 23.411 19.71 23.1924 19.47L18.5736 14.3912C18.3549 14.1504 18.051 14.0044 17.7263 13.9841C17.4016 13.9638 17.0819 14.0708 16.8349 14.2825L14.1224 16.6087C13.9063 16.8256 13.7773 17.1143 13.7599 17.42C13.7411 17.7325 13.3836 25.135 19.1236 30.8775C24.1311 35.8837 30.4036 36.25 32.1311 36.25C32.3836 36.25 32.5386 36.2425 32.5799 36.24C32.8855 36.2229 33.174 36.0933 33.3899 35.8762L35.7149 33.1625C35.9267 32.9157 36.034 32.596 36.0139 32.2713C35.9938 31.9467 35.848 31.6426 35.6074 31.4237L30.5274 26.8037Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.63052b220dda6ef6be1a225f311079f5.svg";
export { ForwardRef as ReactComponent };